import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { App as Antapp, ConfigProvider } from "antd";

import "./index.css";
import { themeToken } from "./utils/themeToken";
import { StrictMode } from "react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <StrictMode>
  <ConfigProvider theme={themeToken}>
    <Antapp>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Antapp>
    </ConfigProvider>
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
